var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundAndCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9362_48401",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9362_48401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7497 17.9375C11.5969 17.9653 11.4441 17.9826 11.2913 17.9896C11.1386 17.9965 10.9858 18 10.833 18C9.73579 18 8.70106 17.7917 7.72884 17.375C6.75662 16.9583 5.90592 16.3854 5.17676 15.6562C4.44759 14.9271 3.87467 14.0764 3.45801 13.1042C3.04134 12.1319 2.83301 11.0972 2.83301 10C2.83301 8.88889 3.04134 7.85069 3.45801 6.88542C3.87467 5.92014 4.44759 5.07292 5.17676 4.34375C5.90592 3.61458 6.75662 3.04167 7.72884 2.625C8.70106 2.20833 9.73579 2 10.833 2C11.9441 2 12.9823 2.20833 13.9476 2.625C14.9129 3.04167 15.7601 3.61458 16.4893 4.34375C17.2184 5.07292 17.7913 5.92014 18.208 6.88542C18.6247 7.85069 18.833 8.88889 18.833 10C18.833 10.1528 18.8295 10.3056 18.8226 10.4583C18.8156 10.6111 18.8052 10.7639 18.7913 10.9167L17.333 10.4583V10C17.333 8.19444 16.7011 6.65972 15.4372 5.39583C14.1733 4.13194 12.6386 3.5 10.833 3.5C9.02745 3.5 7.49273 4.13194 6.22884 5.39583C4.96495 6.65972 4.33301 8.19444 4.33301 10C4.33301 11.8056 4.96495 13.3403 6.22884 14.6042C7.49273 15.8681 9.02745 16.5 10.833 16.5C10.9025 16.5 10.9788 16.4965 11.0622 16.4896C11.1455 16.4826 11.2219 16.4792 11.2913 16.4792L11.7497 17.9375ZM17.9163 18.5L14.458 15.0208L13.333 18L10.833 10L18.833 12.5L15.8538 13.6042L19.333 17.0833L17.9163 18.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundAndCursor);
export default __webpack_public_path__ + "static/media/round_and_cursor.70aaa51da0e36c68fbbd067b4fb950ac.svg";
export { ForwardRef as ReactComponent };